import { useEffect, useState } from "react";
import { Download, Printer, Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export function QrDialog({ equipmentId, open, onClose }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!equipmentId || !open) { setData(null); return; }
    api.get(`/equipment/${equipmentId}/qr`).then(({ data }) => setData(data)).catch(() => {});
  }, [equipmentId, open]);

  const pngSrc = data ? `data:image/png;base64,${data.qr_png_base64}` : null;

  const download = () => {
    const a = document.createElement("a");
    a.href = pngSrc; a.download = `QR-${data.equipment_name}.png`; a.click();
  };
  const copy = () => { navigator.clipboard.writeText(data.qr_token); toast.success("Código copiado"); };
  const print = () => {
    const w = window.open("", "_blank");
    w.document.write(`<html><head><title>Etiqueta QR</title><style>body{font-family:sans-serif;text-align:center;padding:40px}h2{margin:4px}img{width:260px}</style></head><body>
      <h3>${data.organization_name || ""}</h3><h2>${data.equipment_name}</h2>
      <p>${data.location_name} · ${data.area_name}</p><img src="${pngSrc}"/>
      <p style="margin-top:12px;font-weight:600">Escanea para registrar temperatura</p>
      </body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader><DialogTitle className="font-display">Código QR del equipo</DialogTitle></DialogHeader>
        {!data ? <div className="py-10 text-center"><Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" /></div> : (
          <div className="text-center">
            <div className="rounded-2xl border border-slate-200 p-5">
              <p className="text-xs text-slate-400">{data.organization_name}</p>
              <p className="font-display text-lg font-semibold">{data.equipment_name}</p>
              <p className="text-xs text-slate-500">{data.location_name} · {data.area_name}</p>
              <img src={pngSrc} alt="QR" className="mx-auto my-3 w-44" />
              <p className="text-sm font-medium text-slate-600">Escanea para registrar temperatura</p>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-2">
              <Button data-testid="qr-download-btn" variant="outline" size="sm" onClick={download} className="rounded-xl"><Download className="h-4 w-4" /></Button>
              <Button data-testid="qr-print-btn" variant="outline" size="sm" onClick={print} className="rounded-xl"><Printer className="h-4 w-4" /></Button>
              <Button data-testid="qr-copy-btn" variant="outline" size="sm" onClick={copy} className="rounded-xl"><Copy className="h-4 w-4" /></Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
